import { toast } from "@assetwatch/ui";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  type MotionAmplificationJobId,
  updateMotionAmplificationJob,
} from "../clients/motion-amplification";
import i18n from "../i18n/config";
import {
  motionAmplificationJobDetailKey,
  motionAmplificationJobsListKey,
} from "../queries/useMotionAmplificationJobsQuery";

export function useUpdateMotionAmplificationJobMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["motion-amplification", "update-job"],
    mutationFn: ({
      jobId,
      name,
      machineId,
    }: {
      jobId: MotionAmplificationJobId;
      name: string;
      machineId: string | null;
    }) => updateMotionAmplificationJob(jobId, { name, machineId }),
    onSuccess: async (job) => {
      queryClient.setQueryData(motionAmplificationJobDetailKey(job.jobId), job);
      await queryClient.invalidateQueries({
        queryKey: motionAmplificationJobsListKey,
      });
      toast.add(i18n.t("motionAmplification.videoDetailsSaved"));
    },
  });
}
